import React from 'react';
import { DragDropUpload } from 'app/components';
import { UploadedFileCard } from 'app/components/Sections/UploadedDocument/UploadedDocument';
import { IUploadSection } from './UploadSection.interface';

export const UploadSection: React.FC<IUploadSection> = ({
  file,
  isDragging,
  errorText,
  fileHandlers,
  uploadText
}) => {
  const {
    handleUploadFile,
    handleDrop,
    handleDragOver,
    handleDragEnter,
    handleDragLeave,
    handleDeleteFile
  } = fileHandlers;

  return (
    <>
      {file ? (
        <UploadedFileCard
          file={file}
          showDelete
          lenghtTextDisplay={100}
          handleDeleteFile={handleDeleteFile}
          fileSize={file.size}
          styleFileOptions={{
            width: '100%',
            borderRadius: '1rem'
          }}
        />
      ) : (
        <DragDropUpload
          handleDrop={handleDrop}
          handleDragOver={handleDragOver}
          handleDragEnter={handleDragEnter}
          handleDragLeave={handleDragLeave}
          handleButtonClick={handleUploadFile}
          isDragging={isDragging}
          errorText={errorText}
          uploadText={uploadText}
        />
      )}
    </>
  );
};
